import moodleCourseHome from "./index";
import MoodleCourseManager from "./_components/moodle-course-manager.vue";
import PERMISSIONS from "../Common/permissions";

export default {
  path: "moodle-course",
  component: moodleCourseHome,
  children: [
    {
      path: "",
      name: "moodleCourses",
      component: MoodleCourseManager,
      meta: {
        title: "Moodle Course Manager",
        user: "employee",
        permissions: [PERMISSIONS["CAMPUS-DRIVE"]["MOODLE"].MENU],
        checkAll: true,
      },
    },
  ],
};
